// noinspection JSCheckFunctionSignatures

export class MediaError extends Error {
    constructor(type) {
        super(`Cannot access video stream (${type}).`);
        this.type = type;
    }
}

export class Camera {
    constructor(id, name) {
        this.id = id;
        this.name = name;
        this._stream = null;
    }

    async start(videoWidth, videoHeight) {
        this._stream = await Camera._wrapErrors(async () => {
            let videoOpts = {
                deviceId: {
                    exact: this.id
                },
                facingMode: "environment"
            };
            if (videoWidth) {
                videoOpts.width = {ideal: videoWidth};
            }
            if (videoHeight) {
                videoOpts.height = {ideal: videoHeight};
            }

            return await navigator.mediaDevices.getUserMedia({
                audio: false,
                video: videoOpts
            });
        });

        console.log("Video size = " + this._stream.getVideoTracks()[0].getSettings().width + " x " + this._stream.getVideoTracks()[0].getSettings().height);

        return this._stream;
    }

    stop() {
        if (!this._stream) {
            return;
        }

        for (let stream of this._stream.getTracks()) {
            stream.stop();
        }

        this._stream = null;
    }

    static cameraName(label) {
        let clean = label.replace(/\s*\([0-9a-f]+(:[0-9a-f]+)?\)\s*$/, '');
        return clean || label || null;
    }

    static async getCameras() {
        await this._ensureAccess();

        let devices = await navigator.mediaDevices.enumerateDevices();

        return devices
            .filter(d => d.kind === 'videoinput')
            .map(d => new Camera(d.deviceId, Camera.cameraName(d.label)));
    }

    static async _ensureAccess() {
        return this._wrapErrors(async () => {
            let access = await navigator.mediaDevices.getUserMedia({video: true});
            for (let stream of access.getTracks()) {
                stream.stop();
            }
        });
    }

    static async _wrapErrors(fn) {
        try {
            return fn();
        } catch (e) {
            if (e.name) {
                throw new MediaError(e.name);
            } else {
                throw e;
            }
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/app/qr-code-reader/instascan/camera.js
// module id = null
// module chunks = 